// ══════════════════════════════════════════════════════════════
// COMPASS – Notification (In-App Feed) State Model
// ══════════════════════════════════════════════════════════════
import { Notification } from './notification.model';

export interface NotificationState {
  items: Notification[];
  unreadCount: number;
  loadingBell: boolean;
  polling: boolean;
  error: string | null;
}

export const initialNotificationState: NotificationState = {
  items: [],
  unreadCount: 0,
  loadingBell: false,
  polling: false,
  error: null,
};
